// pages/Home.jsx
import React from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/sections/home/Hero';
import Services from '../components/sections/home/Services';
import Support from '../components/sections/home/Support';
import Clients from '../components/sections/home/Clients';
import CallToAction from '../components/sections/home/CallToAction';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <Support />
      <Clients />
      <CallToAction />
    </>
  );
};

export default Home;